import React from 'react';
import ServicePage from '../components/ServicePage';
import { pageContent as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';

const DuctSealing = () => {
  const { pageContent = fb } = useContent();
  return <ServicePage data={pageContent.ductSealing} />;
};
export default DuctSealing;
